import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPassword]',
})
export class PasswordDirective {
  private _shown = false;

  constructor(private elRef: ElementRef) {
    this.setup();
  }

  public toggle(button: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.elRef.nativeElement.setAttribute('type', 'text');
      button.classList.remove('open');
    } else {
      this.elRef.nativeElement.setAttribute('type', 'password');
      button.classList.add('open');
    }
  }

  public setup() {
    const parent = this.elRef.nativeElement.parentNode;
    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add('postfix', 'icon-button', 'eye-button', 'open');
    button.style.right = '2px';
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.toggle(button);
    });
    parent.appendChild(button);
  }
}
